"use strict";

jQuery(document).ready(function () {
  ShowAndHideFaqs();
  hideActiveTab();
  applyPageShowHide();
  var gaCode = getCookie("_ga");
  jQuery('.elementor-search-form__toggle').click(function (event) {
    event.preventDefault();
    if (event.target.className == 'fas fa-search') {
      jQuery('.elementor-search-form__toggle').html('<i class="eicon-close" aria-hidden="true"></i>');
      //jQuery('.dialog-close-button').html('<i aria-hidden="true" class="fas fa-search"></i>');
      jQuery('.dialog-close-button').html('<input id="inptSearchBtn" value="" title="search" type="submit">');
    } else {
      jQuery('.dialog-close-button').html('<i class="eicon-close" aria-hidden="true"></i>');
      jQuery('.elementor-search-form__toggle').html('<i aria-hidden="true" class="fas fa-search"></i>');
    }
  });
  jQuery('.dialog-lightbox-close-button').on('click', function (event) {
    jQuery('.elementor-search-form').submit();
  });

  //set form button select to current program code
  jQuery(document).on('click', '.apply-now-popup, .request-info-popup-LP', function (event) {
    var code = jQuery(this).attr('data-program-code');
    console.log(code);
    popupformSelectOption(code);
  });
  jQuery('.cf-program-details-btn-close .elementor-button').on('click', function (event) {
    if (jQuery("body").hasClass('mobile')) {
      jQuery('html, body').animate({
        scrollTop: jQuery('#degree-showcase-main').offset().top
      }, "800");
    }
  });
  function searchResults() {
    var searchUrlToNavigate = "/search/?q";
    var queryStringParam = jQuery('.elementor-search-form__input').val();
    window.location = searchUrlToNavigate + queryStringParam;
  }
  jQuery('.linkbox').click(function () {
    jQuery(this).toggleClass('open');
  });
});
function getCookie(c_name) {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
}
function ShowAndHideFaqs() {
  jQuery('#showHideFaqs').click(function () {
    if (jQuery('#showHideFaqs').text() == 'Close All [-]') {
      jQuery('.elementor-widget-container .elementor-tab-title').removeClass('elementor-active');
      jQuery('.elementor-widget-container .elementor-tab-content').hide();
      jQuery('#showHideFaqs').text('Expand All [+]');
    } else {
      jQuery('.elementor-widget-container .elementor-tab-title').addClass('elementor-active');
      jQuery('.elementor-widget-container .elementor-tab-content').show();
      jQuery('#showHideFaqs').text('Close All [-]');
    }
  });
}

/* Accessibility js */
jQuery('.cf-course-item .cf-course-title').attr('role', 'none');
jQuery('.cf-industry-item .cf-degree-levels-title').attr('role', 'none');

/* Landing page closing active tab */
function hideActiveTab() {
  jQuery('.cf-programs-groups-tab-menu .elementor-tab-title').removeClass('elementor-active');
}
function applyPageShowHide() {
  jQuery('.apply-page-form-footer').hide();
  jQuery('.select-for-apply-page').change(function () {
    if (jQuery('option:selected', this).text() == 'Program of Interest') jQuery('.apply-page-form-footer').hide();else jQuery('.apply-page-form-footer').show();
    var selectedOptionText = jQuery('option:selected', this).text();
    jQuery('.admission_requirements span').html(selectedOptionText + ' online ');
  }).trigger('change');
}
jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
  var selectedOptionText = jQuery('.select-for-apply-page option:selected').text();
  jQuery('.admission_requirements span').html(selectedOptionText + ' online ');
});

//wcag edits
jQuery(document).on('click', '.elementor-button, .request-info-popup', function (e) {
  jQuery('.dialog-close-button').attr({
    role: "button",
    "aria-label": "Close dialog"
  });

  // WCAG - add all the elements inside modal which you want to make focusable (keeps tab inside of modal)
  var modal = document.querySelector('.elementor-popup-modal'); // select the modal by it's id
  var focusableElements = jQuery(modal).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  var firstFocusableElement = focusableElements.first(); // get first element to be focused inside modal
  var lastFocusableElement = focusableElements.last(); // get last element to be focused inside modal

  /*set focus on first input*/
  firstFocusableElement.focus();

  /*redirect last tab to first input*/
  lastFocusableElement.on('keydown', function (e) {
    if (e.which === 9 && !e.shiftKey) {
      e.preventDefault();
      firstFocusableElement.focus();
    }
  });

  /*redirect first shift+tab to last input*/
  firstFocusableElement.on('keydown', function (e) {
    if (e.which === 9 && e.shiftKey) {
      e.preventDefault();
      lastFocusableElement.focus();
    }
  });
});

//validation after submit for input
jQuery(document).on('focusout', '.ap-lead-form input', function (e) {
  if (jQuery(this).val()) {
    jQuery(this).parent().parent().removeClass('gfield_error');
    jQuery(this).parent().next('div').hide('validation_message');
  }
});

//validation after submit for select
jQuery(document).on('change', '.ap-lead-form select', function (e) {
  jQuery(this).parent().parent().removeClass('gfield_error');
  jQuery(this).parent().next('div').hide('validation_message');
});
jQuery(document).on('focusout', '.apply-lead-form input', function (e) {
  if (jQuery(this).val()) {
    jQuery(this).parent().parent().removeClass('gfield_error');
    jQuery(this).parent().next('div').hide('validation_message');
  }
});
jQuery(document).on('change', '.apply-lead-form select', function (e) {
  jQuery(this).parent().parent().removeClass('gfield_error');
  jQuery(this).parent().next('div').hide('validation_message');
});

//for program poup so that select option matches program clicked on
var modalInterval;
function popupformSelectOption(programsCode) {
  //jQuery('.cf-programs-list select').val(code);
  var currentProgramCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var $modal = jQuery('body').find('.elementor-popup-modal');
  var $popupForm = $modal.find('.ap-lead-form');
  var $programsList = $popupForm.find('.cf-programs-list select');
  var time = 50; // Check to see if the modal's content is loaded.

  //console.log(currentProgramCode);

  if ($popupForm.length) {
    if ($programsList.length) {
      time = 0;
    }
  } // Wait until the modal's content is full loaded.

  clearInterval(modalInterval);
  modalInterval = setInterval(function () {
    if (time !== 0) {
      $modal = jQuery('body').find('.elementor-popup-modal');
      $popupForm = $modal.find('.ap-lead-form');
      $programsList = $popupForm.find('.cf-programs-list select');
    }
    if ($popupForm.length) {
      if ($programsList.length) {
        clearInterval(modalInterval); // Go through all the Program Options and check to see if the program must be removed from the list, or not.

        if (programsCode) {
          $programsList.find("option[value=".concat(programsCode, "]")).attr('selected', 'selected');
        }
      }
    }
  }, time);
}

// -------------------- DEFINE VARIABLES --------------------

var animationSpeed = 250;
var animationSpeedSlow = 450;
var availableViewSpace;
var currentStickyTop;
var enableScrollFunctions = 0;
var hashTargetTop;
var headerHeightScrollDown;
var headerHeightAtTop;
var headerHeightScrollUpSome;
var headerHeightScrollTop;
var myMaxHeight = 0;
var myMinHeight;
var offsetScrollPosition = 0;
var pageLoadFlag = 1;
var prevScrollPosition = 0;
var scrollOffset = 0;
var scrollPosition = 0;
var scrollPositionOffset = 0;
var scrollThreshold = 5;
var scrollTimeout;
var stickyHeight;
var targetHREF;
var theSectionTop;
var thisSectionsHeight;
var theSectionHeight;
var theSectionBottom;
var thisSectionsBottom;
var theSubnavHREF;
var thisSectionsTop;
var totalHeaderScrollDownHideHeight = 0;
var totalHeaderScrollDownHideHeightTopOnly = 0;

// -------------------- END DEFINE VARIABLES --------------------

// -------------------- ON PAGE LOAD EVENT --------------------
(function ($) {
  jQuery(document).ready(function ($) {
    jQuery.noConflict();

    // set body class to desktop by default, then run check
    $("body").addClass("desktop");
    detectDesktopOrMobile();
    // move elements that switch positions between desktop and mobile
    moveThis();
    // initialize position, heights, related values
    initializePage();
    // if page loads with hash in URL, run handler to put page at correct location
    if (window.location.hash) {
      goToHash($(location).attr('hash'));
    }
    // wait 100 ms for all script checks to run, then reset page load flag and enable the scroll functions. This prevents any scroll-based functions from accidentally triggering on page load
    setTimeout(function () {
      enableScrollFunctions = 1;
      pageLoadFlag = 0;
      headerHeightHandler();
    }, 200);
  });

  // -------------------- END ON PAGE LOAD --------------------

  // -------------------- EVENTS --------------------

  // EVENT : scrolling
  $(window).scroll(function () {
    if (scrollTimeout) {
      // clear the timeout, if one is pending
      clearTimeout(scrollTimeout);
      scrollTimeout = null;
    }
    scrollTimeout = setTimeout(scrollHandler, 10);
  });

  // EVENT : resizing window
  $(window).resize(function () {
    // determine responsive view
    detectDesktopOrMobile();
    headerHeightHandler();
    tableScrolling();
  });

  // EVENT: clicking an anchor link
  $(document).on('click', 'a[href^="#"]', function (event) {
    // optional: prevent # id from appearing in URL bar
    event.preventDefault();

    // get the hash target
    targetHREF = $.attr(this, 'href');
    // optional: change URL bar, but not if the href is "#top" or "#"
    if (targetHREF != "#top" && targetHREF != "#") {
      history.pushState(null, null, targetHREF);
    }
    // when the hash is #, it could mean different things. This cycles through the options and triggers a corresponding function
    if (targetHREF == "#") {
      if ($(this).hasClass("search-open") || $(this).hasClass("search-close")) {
        searchShowHide(this);
      }

      // basic show-hides
      if ($(this).hasClass("show-link")) {
        event.stopPropagation();
        if ($(this).closest(".show-link-parent").next(".show-content").css("display") == "none") {
          $(this).closest(".show-link-parent").next(".show-content").slideDown('fast');
          $(this).children().each(function () {
            showHideTogglesOpened($(this));
          });
          tableScrolling();
        } else {
          $(this).closest(".show-link-parent").next(".show-content").slideUp('fast');
          $(this).children().each(function () {
            showHideTogglesClosed($(this));
          });
        }
      }

      // expand/contract fixed-height-fade-content elements
      if ($(this).parent().hasClass("fixed-height-fade-content-toggle")) {
        fixedHeightContent(this);
      }
    } else {
      // run hash animation handler
      goToHash(targetHREF);
    }
  });

  // EVENT: when the URL hash changes, reload page completely to reset various parameters
  $(window).on("hashchange", function (event) {
    location.reload();
  });

  // -------------------- END EVENTS --------------------

  // -------------------- CALLABLE FUNCTIONS --------------------

  // FUNCTION : handle back-to-top link in fixed footer
  function backToTop(direction) {
    if ($("body").hasClass("desktop") && !$(".back-to-top").hasClass("mobile-only")) {
      // scrolling down
      if (direction == "down") {
        $(".back-to-top").hide();
      }
      // scrolled up
      else {
        if (scrollPosition < headerHeightAtTop) {
          // hide back-to-top
          $(".back-to-top").hide();
        } else {
          // show back-to-top
          $(".back-to-top").show();
        }
      }
    } else if ($("body").hasClass("mobile") && !$(".back-to-top").hasClass("desktop-only")) {
      // scrolling down
      if (direction == "down") {
        $(".back-to-top").hide();
      }
      // scrolled up
      else {
        if (scrollPosition < headerHeightAtTop) {
          // hide back-to-top
          $(".back-to-top").hide();
        } else {
          // show back-to-top
          $(".back-to-top").show();
        }
      }
    }
  }

  // FUNCTION : detect desktop or mobile view based on CSS
  function detectDesktopOrMobile() {
    // detect if desktop
    if ($("body").css("max-width") != "9999px") {
      // detect if transitioning to desktop from mobile
      if ($("body.mobile").length) {
        $('body').removeClass('mobile');
        $('body').addClass('desktop');
        moveThis();
        // reset show/hides, heights, positioning
        initializePage();
      }
    }
    // detect if mobile
    else {
      // detect if transitioning to mobile from desktop
      if ($("body.desktop").length) {
        $('body').removeClass('desktop');
        $('body').addClass('mobile');
        moveThis();
        // reset show/hides, heights, positioning
        initializePage();
      }
    }
  }

  // FUNCTION : fixed-height elements with fade
  function fixedHeightContent(target) {
    myParent = $(target).closest(".fixed-height-fade-content");
    if ($(myParent).hasClass("closed")) {
      myMinHeight = $(myParent).innerHeight();
      $(myParent).removeClass("closed");
      if (myMaxHeight == 0) {
        myMaxHeight = $(myParent).innerHeight() + $(target).height();
      }
      $(myParent).css({
        "max-height": myMinHeight
      });
      $(myParent).animate({
        "max-height": myMaxHeight
      }, animationSpeed);
      $(target).addClass("open");
    } else {
      myMaxHeight = $(myParent).innerHeight();
      $(myParent).addClass("closed");
      $(myParent).animate({
        "max-height": myMinHeight
      }, animationSpeed);
      $(target).removeClass("open");
    }
  }

  // FUNCTION: handle navigating to a hash target
  function goToHash(hashTarget) {
    // if the hashtag is not just # <-- not necessary anymore, but retaining just in case
    if (hashTarget != "#") {
      // if the target is the top
      if (hashTarget == "#top") {
        $('html, body').animate({
          scrollTop: 0
        }, animationSpeed, function () {
          subnavActive();
        });
      }
      // if target is not top
      else {
        // get target top value
        hashTargetTop = $(hashTarget).offset().top;
        // initialize scroll offset value for the hash target. This is what adjusts the scroll amount to account for fixed header size.
        scrollOffset = 0;
        // only do this if header is fixed and offset is required
        if ($(".header").hasClass("fixed")) {
          // initialize scroll offset value for the hash target. This is what adjusts the scroll amount to account for fixed header size.
          scrollOffset = 0;
          // calculate the scroll offset:
          // go through each visible, top-sticky sibling of the fixed header and look for the target. If it's not there, add the height of this element to the scroll offset total.
          $(".header.fixed").siblings().each(function () {
            if ($(this).find(hashTarget).length <= 0 && $(this).hasClass("top-sticky") && $(this).is(":visible")) {
              scrollOffset = scrollOffset + $(this).outerHeight();
            }
          });

          // if page is just now being loaded, i.e. clicked link on another page to get here
          if (pageLoadFlag == 1) {
            //since page is already at top, header is full height. The new target scroll position should equal the full height of the header plus the total height of the visible top-sticky header siblings.
            hashTargetTop = hashTargetTop - headerHeightAtTop - scrollOffset;
            // since page is loading, no scroll animation is desired - just jump to the target point
            $('html, body').animate({
              scrollTop: hashTargetTop
              //}, 0);
            }, 10, function () {
              subnavActive();
            }); // if needing to scroll down because page is reset
          }

          // if page is already loaded, i.e. link clicked on same page
          else {
            // if navigating to hash target involves scrolling down
            if (hashTargetTop > scrollPosition) {
              // offset (decrease) target position by the predicted height of the header after scrolling down and the total height of the visible top-sticky header siblings.
              hashTargetTop = hashTargetTop - headerHeightScrollDown - scrollOffset;
            }
            // if navigating to hash target involves scrolling up
            else if (hashTargetTop < scrollPosition) {
              // offset (decrease) target position by the predicted height of the header after scrolling up some and the total height of the visible top-sticky header siblings.
              hashTargetTop = hashTargetTop - headerHeightScrollUpSome - scrollOffset;
            }
            // if already at hash target position, just exit
            else if (hashTargetTop == scrollPosition) {
              return;
            }
            // scroll to offset target point, slightly slower than animation speed
            $('html, body').animate({
              scrollTop: hashTargetTop
            }, animationSpeed + 100, function () {
              subnavActive();
            });
          }
        }
      }
    }
  }

  // FUNCTION : handle header/fixed/sticky element heights
  function headerHeightHandler() {
    // only do this if header is fixed
    if ($(".header").hasClass("fixed")) {
      // desktop and mobile views are handled separately
      if ($("body").hasClass("desktop")) {
        // predict height of header when scrolled down. Start with initial value of header at top
        headerHeightScrollDown = headerHeightAtTop;
        // then subtract the heights of each element that will hide on scroll down
        $(".desktop-scroll-down-hide").each(function () {
          headerHeightScrollDown = headerHeightScrollDown - $(this).outerHeight();
        });
        // predict height of header when scrolled up but not all the way to top. Start with value of header when scrolled down
        headerHeightScrollUpSome = headerHeightScrollDown;
        // then add the heights of each element that will show on scroll up
        $(".desktop-scroll-up-show").each(function () {
          headerHeightScrollUpSome = headerHeightScrollUpSome + $(this).outerHeight();
        });
        // predict height of header when scrolled to top. In this case, it should already equal the initial value of header at top because you can't scroll down to get to the top anyway.
        headerHeightScrollTop = headerHeightAtTop;
      }
      // desktop and mobile views are handled separately
      else if ($("body").hasClass("mobile")) {
        // predict height of header when scrolled down. Start with initial value of header at top
        headerHeightScrollDown = headerHeightAtTop;
        // then subtract the heights of each element that will hide on scroll down
        $(".mobile-scroll-down-hide").each(function () {
          headerHeightScrollDown = headerHeightScrollDown - $(this).outerHeight();
        });
        // predict height of header when scrolled up but not all the way to top. Start with value of header when scrolled down
        headerHeightScrollUpSome = headerHeightScrollDown;
        // then add the heights of each element that will show on scroll up
        $(".mobile-scroll-up-show").each(function () {
          headerHeightScrollUpSome = headerHeightScrollUpSome + $(this).outerHeight();
        });
        // predict height of header when scrolled to top. In this case, it should already equal the initial value of header at top because you can't scroll down to get to the top anyway.
        headerHeightScrollTop = headerHeightAtTop;
      }
    }
    $(".top-sticky:visible").each(function () {
      stickyHeight = $(this).outerHeight();
      availableViewSpace = $(window).height() - headerHeightScrollDown;
      $(".fixed").not(".header").each(function () {
        availableViewSpace = availableViewSpace - $(this).outerHeight();
      });
      currentStickyTop = $(this).offset().top;
      $(".top-sticky:visible").each(function () {
        if ($(this).offset().top < currentStickyTop) {
          availableViewSpace = availableViewSpace - $(this).outerHeight();
        }
      });
      if (stickyHeight >= availableViewSpace) {
        $(this).css({
          "position": "relative"
        });
        $(this).css({
          "top": "auto"
        });
      } else {
        $(this).css({
          "position": "sticky"
        });
      }
    });
  }

  // FUNCTION : initialize positions, heights, related values
  function initializePage() {
    headerHeightAtTop = $(".header").outerHeight();
    $("body").css({
      "padding-top": headerHeightAtTop
    });
    $("body.landing-page").css({
      "padding-top": 0
    });
    scrollPosition = $(this).scrollTop();
    prevScrollPosition = scrollPosition;
    if ($("body").hasClass("desktop")) {
      $(".desktop-scroll-down-hide").show();
      $(".mobile-scroll-down-hide").show();
    } else if ($("body").hasClass("mobile")) {
      $(".desktop-scroll-down-hide").show();
      $(".mobile-scroll-down-hide").show();
    }
    headerHeightHandler();
    setTopStickyTops(headerHeightAtTop);
    $(".content-section").each(function () {
      thisSectionsTop = $(this).offset().top;
      thisSectionsHeight = $(this).outerHeight();
      thisSectionsBottom = thisSectionsTop + thisSectionsHeight;
      $(this).find(".sectionTop").text("top: " + thisSectionsTop + ", height: " + thisSectionsHeight + ", bottom: " + thisSectionsBottom);

      //$(this).find(".sectionTop").text( "top: "+$(this).offset().top+", bottom );
    });
    setTimeout(tableScrolling, 1);

    //$(".msg").text(scrollPosition);
  }

  // FUNCTION : Move things from one area to another on mobile-desktop switch
  function moveThis() {
    // Instructions: give the item you want to move the '.moveThis' class and an ID. Give the two alternating containers the same ID with -desktop and -mobile appended.
    $('.move-this').each(function () {
      var moveTargetID = $(this).attr('id');
      // Mobile
      if ($("body").hasClass("mobile")) {
        if ($("#" + moveTargetID + "-mobile #" + moveTargetID + "").length == 0) {
          $("#" + moveTargetID + "").appendTo($("#" + moveTargetID + "-mobile"));
        }
      }
      // Desktop
      else if ($("body").hasClass("desktop")) {
        if ($("#" + moveTargetID + "-desktop #" + moveTargetID + "").length == 0) {
          $("#" + moveTargetID + "").appendTo($("#" + moveTargetID + "-desktop"));
        }
      }
    });
  }

  // FUNCTION : handle what happens when you scroll
  function scrollHandler() {
    // get current scroll position
    scrollPosition = $(this).scrollTop();
    // make sure scroll amount is significant, else cancel
    if (Math.abs(prevScrollPosition - scrollPosition) <= scrollThreshold) {
      return;
    }
    // make sure scrolling functions are enabled, else cancel
    if (enableScrollFunctions == 0) {
      return;
    }
    // if scrolled down
    if (prevScrollPosition < scrollPosition && enableScrollFunctions == 1) {
      // show/hide any elements that are set to do so on scroll down, and adjust positions of related elements
      scrollShowHides("down");
      backToTop("down");
      headerHeightHandler();
    }
    // if scrolled up
    else if (prevScrollPosition > scrollPosition && enableScrollFunctions == 1) {
      headerHeightHandler();
      if (scrollPosition + $(window).height() < $(document).height()) {
        // scrolled to "top" (from zero to minimum height of fixed header)
        if (scrollPosition < headerHeightScrollDown) {
          // show/hide any elements that are set to do so on scroll to top, and adjust positions of related elements
          scrollShowHides("top");
        }
        // just scrolled up some, but not all the way to top
        else {
          // show/hide any elements that are set to do so on scroll up, and adjust positions of related elements
          scrollShowHides("up");
          backToTop("up");
        }
      }
    }
    subnavActive();

    //setTimeout( $(".msg").text(scrollPosition), animationSpeed+50 );

    // mark current position as previous to prepare for further scrolling
    prevScrollPosition = scrollPosition;
  }

  // FUNCTION : handle scroll-based show/hides
  function scrollShowHides(direction) {
    if ($("body").hasClass("desktop")) {
      // scrolling down
      if (direction == "down") {
        // check if the entire header is meant to hide, and if so only do this if scrolled past header; otherwise just allow 100 px margin from top before activating
        if ($(".header").hasClass("desktop-scroll-down-hide") && scrollPosition > headerHeightAtTop || !$(".header").hasClass("desktop-scroll-down-hide") && scrollPosition > 100) {
          // hide/slide up each scroll-down-hide element
          $(".desktop-scroll-down-hide:visible").each(function () {
            $(this).slideUp(animationSpeedSlow, "swing");
            // hide any custom search overlays inside this element and switch any toggles to close
            $(this).find(".custom-search").hide();
            $(this).find(".search-toggle.search-close").addClass("search-open");
            $(this).find(".search-toggle.search-close").removeClass("search-close");
          });
          // adjust top-sticky positions to account for height of header when scrolled down
          setTopStickyTops(headerHeightScrollDown);
        }
      }
      // scrolled to top of page
      else if (direction == "top") {
        // show/slide down each scroll-top-show element
        $(".desktop-scroll-top-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // show/slide down each scroll-up-show element
        $(".desktop-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when at top of page
        setTopStickyTops(headerHeightScrollTop);
      }
      // scrolled up a certain amount but not to top of page
      else if (direction == "up") {
        // show/slide down each scroll-up-show element
        $(".desktop-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // if you're scrolling up, but top-only elements are visible, i.e. on page load, where the whole header is reset
        $(".desktop-scroll-top-show:visible").each(function () {
          $(this).slideUp(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when scrolled up some amount
        setTopStickyTops(headerHeightScrollUpSome);
      }
    } else if ($("body").hasClass("mobile")) {
      // scrolling down
      if (direction == "down") {
        // check if the entire header is meant to hide, and if so only do this if scrolled past header; otherwise just allow 100 px margin from top before activating
        if ($(".header").hasClass("mobile-scroll-down-hide") && scrollPosition > headerHeightAtTop || !$(".header").hasClass("mobile-scroll-down-hide") && scrollPosition > 100) {
          // hide/slide up each scroll-down-hide element
          $(".mobile-scroll-down-hide:visible").each(function () {
            $(this).slideUp(animationSpeedSlow, "swing");
          });
          // adjust top-sticky positions to account for height of header when scrolled down
          setTopStickyTops(headerHeightScrollDown);
        }
      }
      // scrolled to top of page
      else if (direction == "top") {
        // show/slide down each scroll-top-show element
        $(".mobile-scroll-top-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // show/slide down each scroll-up-show element
        $(".mobile-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when at top of page
        setTopStickyTops(headerHeightScrollTop);
      }
      // scrolled up a certain amount but not to top of page
      else if (direction == "up") {
        // show/slide down each scroll-up-show element
        $(".mobile-scroll-up-show:hidden").each(function () {
          $(this).slideDown(animationSpeedSlow, "swing");
        });
        // if you're scrollin up, but top-only elements are visible, i.e. on page load, where the whole header is reset
        $(".mobile-scroll-top-show:visible").each(function () {
          $(this).slideUp(animationSpeedSlow, "swing");
        });
        // adjust top-sticky positions to account for height of header when scrolled up some amount
        setTopStickyTops(headerHeightScrollUpSome);
      }
    }
  }

  // FUNCTION : set top values for any visible top-sticky elements
  function setTopStickyTops(topStickyBasis) {
    // start by adjusting the top value by some base amount, usually the predicted height of the header after a given scroll
    var topStickyTop = topStickyBasis;
    // for each visible top-sticky element, set the new top amount to equal the base amount, then increment the base amount by the height of the element that was just handled
    $(".top-sticky:visible").each(function () {
      if ($(this).css("position") == "sticky") {
        $(this).css({
          "top": topStickyTop
        });
        scrollPositionOffset = topStickyTop;
        topStickyTop = topStickyTop + $(this).outerHeight();
      }
    });
  }

  // FUNCTION : show/hide the custom search bar
  function searchShowHide(target) {
    if ($(target).hasClass("search-open")) {
      if ($(target).hasClass("search-toggle")) {
        $(target).removeClass("search-open");
        $(target).addClass("search-close");
      }
      if ($(target).closest(".header-search").hasClass("slide-down")) {
        $(target).closest(".header-search").find(".custom-search").slideDown('fast');
      }
      if ($(target).closest(".header-search").hasClass("slide-left")) {
        $(target).closest(".header-search").find(".custom-search").animate({
          width: "100%"
        }, animationSpeed, function () {});
      }
    } else if ($(target).hasClass("search-close")) {
      if ($(target).hasClass("search-toggle")) {
        $(target).removeClass("search-close");
        $(target).addClass("search-open");
      }
      if ($(target).closest(".header-search").hasClass("slide-down")) {
        $(target).closest(".header-search").find(".custom-search").slideUp('fast');
      }
      if ($(target).closest(".header-search").hasClass("slide-left")) {
        $(target).closest(".header-search").find(".custom-search").animate({
          width: "0"
        }, animationSpeed, function () {});
      }
    }
  }

  // FUNCTIONS: these two functions swap show/hide text pairs
  function showHideTogglesOpened(thisObj) {
    if (thisObj.hasClass('view-close')) {
      thisObj.html('Close');
    }
    if (thisObj.hasClass('show-hide')) {
      thisObj.html('Hide');
    }
    if (thisObj.hasClass('more-less')) {
      thisObj.html('less');
    }
    if (thisObj.hasClass('right-down')) {
      thisObj.children('img').css({
        'transform': 'rotate(90deg)'
      });
    }
    if (thisObj.hasClass('plus-minus')) {
      thisObj.html('&ndash;');
    }
    if (thisObj.hasClass('expand-close')) {
      thisObj.html('Close [&nbsp;&ndash;&nbsp;]');
    }
    if (thisObj.hasClass('plus-minus-brackets')) {
      thisObj.html('[&nbsp;&ndash;&nbsp;]');
    }
  }
  function showHideTogglesClosed(thisObj) {
    if (thisObj.hasClass('view-close')) {
      thisObj.html('View');
    }
    if (thisObj.hasClass('show-hide')) {
      thisObj.html('Show');
    }
    if (thisObj.hasClass('more-less')) {
      thisObj.html('more');
    }
    if (thisObj.hasClass('right-down')) {
      thisObj.children('img').css({
        'transform': 'rotate(0deg)'
      });
    }
    if (thisObj.hasClass('plus-minus')) {
      thisObj.html('+');
    }
    if (thisObj.hasClass('expand-close')) {
      thisObj.html('Expand [&nbsp;+&nbsp;]');
    }
    if (thisObj.hasClass('plus-minus-brackets')) {
      thisObj.html('[&nbsp;+&nbsp;]');
    }
  }

  // FUNCTION : set subnav items active or not based on scroll position
  function subnavActive() {
    // set a brief timeout so that this doesn't trigger until all scrolling/animating has completed - if this fires too early the numbers will be variable
    setTimeout(function () {
      // get the new adjusted scroll position by adding the offset value from the top-sticky function to the actual scroll position
      offsetScrollPosition = scrollPosition + scrollPositionOffset;
      // for each visible subnav link, get the HREF value; if value exists, define the top and bottom boundaries of that section. If adjusted scroll position falls between those boundaries, set that subnav link to .active, otherwise remove .active.
      $(".subnav a:visible").each(function () {
        theSubnavHREF = $(this).attr("href");
        if ($(theSubnavHREF).length != 0) {
          theSectionTop = $(theSubnavHREF).offset().top;
          theSectionHeight = $(theSubnavHREF).outerHeight();
          theSectionBottom = theSectionTop + theSectionHeight;
          if (offsetScrollPosition >= theSectionTop && offsetScrollPosition < theSectionBottom) {
            $(this).addClass("active");
          } else {
            $(this).removeClass("active");
          }
        }
      });
    }, 10);
  }

  // FUNCTION : resize scrollable tables
  function tableScrolling() {
    $('.table-container').each(function () {
      var tableContHeight = $(this).children('table').outerHeight() + 20;
      $(this).css("height", tableContHeight);
      $(this).addClass('scrollable');
    });
  }

  // -------------------- END CALLABLE FUNCTIONS --------------------
})(jQuery);